import { apiRequest } from "./client";

// A TV show. Episodes are ordinary videos (see content.ts) tagged with the
// show's id + a season/episode number; the backend cascades the show's
// visibility onto them. `thumbUrl` is the first episode's poster.
export type SeriesListItem = {
  id: string;
  title: string;
  description: string | null;
  categories: string[];
  ageMin: number;
  ageMax: number;
  isPremium: boolean;
  isPublic: boolean;
  episodeCount: number;
  thumbUrl: string;
};

export type SeriesEpisode = {
  id: string;
  title: string;
  thumbUrl: string;
  duration: number;
  seasonNumber: number | null;
  episodeNumber: number | null;
  isPremium: boolean;
};

export type SeriesDetail = SeriesListItem & { episodes: SeriesEpisode[] };

// Guest/public shows — the backend hard-scopes to isPublic + not-archived and
// only returns playable (done, public) episodes. Same posture as
// publicContentApi in content.ts. Signed-in surfaces reuse this for now since
// shows are a global catalog, not per-family content.
export const publicSeriesApi = {
  list: (): Promise<{ series: SeriesListItem[]; total: number }> =>
    apiRequest(`/v1/public/series`),

  get: (id: string): Promise<SeriesDetail> =>
    apiRequest(`/v1/public/series/${id}`),
};
